module.exports = __webpack_public_path__ + "img/Coverage-Light.118f31b.svg";